const Loader = ({ isVisible }: { isVisible: boolean }) => {
  if (!isVisible) return null;

  return (
    <div className='fixed inset-0 bg-black/50 dark:bg-white/50 z-[9999] flex items-center justify-center'>
      <div className='h-16 w-16 animate-spin border-[6px] border-[#d7d6d5] border-t-green-400 rounded-full ' />
    </div>
  );
};

export default Loader;
